import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  standalone: false,
  selector: 'app-modal-view-pending-entry',
  templateUrl: './modal-view-pending-entry.component.html',
styleUrls:  ['./modal-view-pending-entry.component.css']
})
export class ModalViewPendingEntryComponent implements OnInit {

  @Input() entry_id: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
